__turbopack_context__.v({
  "itsme-button": "ItsmeButton-module-scss-module__ut7Gpq__itsme-button",
});
